import { Directive, InjectionToken, TemplateRef } from '@angular/core';

export const SELECT_GROUP_CONTENT =
  new InjectionToken<SelectGroupContentDirective>('SelectGroupContent');

@Directive({
  selector: '[appGroup]',
  providers: [
    { provide: SELECT_GROUP_CONTENT, useExisting: SelectGroupContentDirective },
  ],
  standalone: false,
})
export class SelectGroupContentDirective {
  constructor(public template: TemplateRef<any>) {}
}
